import { StyleSheet } from 'react-native';

import { globalSpacing } from '../../Theme/styles';

export default StyleSheet.create({
  submit: { marginTop: 0 },
  marginBottomOffset: { marginBottom: -globalSpacing },
});
